import { useState } from "react";
import { ComboBox } from "../../../components/ComboBox";
import { DateRangePicker } from "../../../components/DateRangePicker";
import { PeriodSelector } from "../../../components/PeriodSelector";
import { IconImg } from "../../../contents/Icons";
import { StyledSection3 } from "./style";
import { KICT, REGIONS } from "../../../consts/const";

import useDateRangeStore from "../../../store/useDateRangeStore";
import useRegionStore from "../../../store/useRegionStore";

const CATEGORY_OPTION = [
  { label: "국토관리사무소", value: "REGIONS" },
  { label: "한국건설기술연구원", value: "KICT" },
];

const REGIONS_OPTION = [
  {
    label: "전체",
    value: "ALL",
  },
  ...REGIONS.map((region) => ({
    ...region,
    label: region.label + "국토관리사무소",
  })),
];

const KICT_OPTION = [...KICT];

export const Section3 = () => {
  const {
    periodStartDate,
    periodEndDate,
    setPeriodStartDate,
    setPeriodEndDate,
  } = useDateRangeStore();
  const { setSelectedRegionList } = useRegionStore();

  const [startDate, setStartDate] = useState(periodStartDate);
  const [endDate, setEndDate] = useState(periodEndDate);

  const [category, setCategory] = useState("REGIONS");
  const [selectedCategory, setSelectedCategory] = useState(
    CATEGORY_OPTION[0].value
  );
  const [selectedRegions, setSelectedRegions] = useState(
    REGIONS_OPTION.map((region) => region.value)
  );
  const [selectedKict, setSelectedKict] = useState([KICT_OPTION[0].value]);

  const handleOnClick = () => {
    let allRegionsSelected;

    if (category === "REGIONS") {
      allRegionsSelected = selectedRegions.includes("ALL")
        ? REGIONS.map((region) => region.value)
        : selectedRegions;
    } else {
      allRegionsSelected = selectedKict;
    }

    if (!allRegionsSelected.length || !startDate || !endDate) {
      alert("조회할 지역과 날짜 범위를 선택해주세요.");
      return;
    }

    setPeriodStartDate(startDate);
    setPeriodEndDate(endDate);
    setSelectedRegionList(allRegionsSelected);
  };

  const handleCategory = (selected) => {
    setSelectedCategory(selected);
    setCategory(selected);
    setSelectedRegions([]);
  };

  const handleRegions = (selected) => {
    if (selected === "ALL") {
      if (selectedRegions.length === REGIONS_OPTION.length) {
        setSelectedRegions([]);
      } else {
        setSelectedRegions(REGIONS_OPTION.map((option) => option.value));
      }
    } else {
      if (selectedRegions.includes(selected)) {
        setSelectedRegions(
          selectedRegions.filter((value) => value !== selected)
        );
      } else {
        setSelectedRegions([...selectedRegions, selected]);
      }
    }
  };

  const handleKict = (selected) => {
    setSelectedKict([selected]);
  };

  return (
    <StyledSection3>
      <span className="line">
        <p className="title">기간별 데이터</p>
      </span>
      <div className="section3-container">
        <ComboBox
          options={CATEGORY_OPTION}
          value={selectedCategory}
          onChange={handleCategory}
        />
        <ComboBox
          placeholder={category === "REGIONS" ? "전체" : "한국건설기술연구원"}
          options={category === "REGIONS" ? REGIONS_OPTION : KICT_OPTION}
          value={category === "REGIONS" ? selectedRegions : selectedKict}
          onChange={category === "REGIONS" ? handleRegions : handleKict}
          multiSelectMode={true}
        />
        <PeriodSelector setStartDate={setStartDate} setEndDate={setEndDate} />
        <DateRangePicker
          startDate={startDate}
          endDate={endDate}
          setStartDate={setStartDate}
          setEndDate={setEndDate}
        />
        <button className="search-btn" onClick={handleOnClick}>
          조회
        </button>
        <button className="download-btn disabled">
          <IconImg.FloppyDist />
          CSV 저장
        </button>
      </div>
    </StyledSection3>
  );
};
